import { contrastRatio } from '@yola/yola-palette-generator';
import increaseColorPointByRatio from '../../../../common/utils/increase-color-point-by-ratio';

const light = (params) => {
  const { targetColor, backgroundColor, targetColorPalette } = params;
  const fallback = {
    rule: 'dropdown.listRowBackground.selected.light',
    params,
  };
  if (contrastRatio(backgroundColor, targetColor) >= 1.1) {
    return targetColor;
  }
  return increaseColorPointByRatio(
    {
      targetColor,
      backgroundColor,
      targetColorPalette,
      condition: (ratio) => ratio >= 1.1,
      fallback,
    },
    '50'
  );
};

export default light;
